import React from 'react';
import * as ds from './dataService';
import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';


export type PlanSetSelectFieldProps<T extends object, K extends keyof T = keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object, K extends keyof T = keyof T>(props: PlanSetSelectFieldProps<T>) => {
  const { data } = ds.useQuery();
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
    />
  );
};
